import React, { useContext, useState } from "react";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import { resizeViewport } from "../../../helpers/CornerstoneViewportService";
import {
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
} from "../../../../../constants/Constants";
import loaderContext from "../../../../../context/loader/LoaderContext";

function LayoutSelector({ handleMouseClick, autoLoad = false }) {
  const { changeLayout, autoLoadSeriesInLayout } = useContext(ViewportContext);

  const rows = VIEWPORT_ROW;
  const columns = VIEWPORT_COLUMN;
  const [hoveredIndex, setHoveredIndex] = useState();
  const {ref, setLoaderRunning} = useContext(loaderContext);
  const hoverX = hoveredIndex % columns;
  const hoverY = Math.floor(hoveredIndex / columns);
  const isHovered = (index) => {
    const x = index % columns;
    const y = Math.floor(index / columns);

    return x <= hoverX && y <= hoverY;
  };

  const setLayout = async (e, index) => {
    e.stopPropagation();
    const columnCount = (index % columns) + 1;
    const rowCount = Math.floor(index / columns) + 1;
    handleMouseClick();
    if (autoLoad) {
      autoLoadSeriesInLayout(rowCount, columnCount);
    } else {
      changeLayout(rowCount, columnCount);
    }
    setTimeout(async() => {
      await resizeViewport();
    },300)
  };

  const gridSize = "15px ";
  return (
    <div
      style={{
        display: "grid",
        justifyContent: "center",
        gridTemplateColumns: gridSize.repeat(columns),
        gridTemplateRows: gridSize.repeat(rows),
        backgroundColor: "#3A3A39", // primary-dark
        columnGap: "4px",
        rowGap: "4px",
        marginTop: "9.5px",
      }}
      className="p-2"
    >
      {Array.apply(null, Array(rows * columns))
        .map(function (_, i) {
          return i;
        })
        .map((index) => {
          return (
            <div
              key={index}
              style={{
                border: "2px solid white",
                borderRadius: "4px",
                backgroundColor: isHovered(index) ? (autoLoad ? "#4da6ff" : "white") : "#3A3A39",
              }}
              className="cursor-pointer"
              onClick={(e) => setLayout(e, index)}
              onMouseEnter={() => {setHoveredIndex(index)}}
              onMouseLeave={() => setHoveredIndex(-1)}
            ></div>
          );
        })}
    </div>
  );
}
export default LayoutSelector;
